export const isDevelopment = () => {
  // Bundlers replace this exact expression even when no browser `process` global exists.
  // A preceding typeof-process check would suppress warnings in those development bundles.
  try {
    return process.env.NODE_ENV !== "production";
  } catch {
    // Unbundled browser modules have no build-mode signal; stay silent there.
    return false;
  }
};

export function devWarn(message: string): void {
  if (isDevelopment()) {
    console.warn(message);
  }
}
